<template>
    <section class="view faq-page">
        <ViewLoader v-if="loading"/>

        <template v-else>
            <ViewHeader>
                <template slot="title">{{ $t('pages.faq.page_title') }}</template>
                <template slot="intro">{{ $t('pages.faq.page_subtitle') }}</template>
            </ViewHeader>

            <div class="container my-5">
                <div class="row d-flex justify-content-center">
                    <div class="col-10 col-md-8 col-lg-5">
                        <div class="w-100">
                            <input type="search" class="form-control form-control-lg"
                                   autocomplete="off" :placeholder="$t('pages.faq.input_search_placeholder')"
                                   v-model="searchInput" @input="searchQuestions">
                            <div id="search-results" v-if="searchInput">
                                <div v-if="searchResults.length === 0" class="h5 px-4 pt-3 pb-2">
                                    {{ $t('pages.faq.input_search_no_results', {term: searchInput}) }}
                                </div>
                                <ul v-else class="list-group list-group-striped w-100">
                                    <li v-for="(question, index) in searchResults" :key="index"
                                        class="list-group-item cursor-pointer"
                                        @click="scrollToQuestion(question)">
                                        <h5> {{ question.q }} </h5>
                                        {{ question.a | truncate(120) }}
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="container container-help">

                <h3 class="text-center font-weight-bolder py-4"> {{ $t('pages.faq.faq_group_selection_title') }} </h3>

                <div class="row" id="help-categories">
                    <div class="col-6 col-lg-3 mb-4" v-for="(group, index) in questionsByGroup" :key="index">
                        <div class="card text-center py-3 h-100 cursor-pointer" @click="scrollToGroup(group)">
                            <img :src="group.icon" class="my-4" height="56rem">
                            <h3> {{ group.group }} </h3>
                        </div>
                    </div>
                </div>

                <div v-for="(group, index) in questionsByGroup" :key="index" :id="group.slug">
                    <h3 class="text-center font-weight-bolder pt-5 pb-4"> {{ group.group }} </h3>
                    <ul class="list-group list-group-flush" v-for="(question, index2) in group.questions" :key="index2">
                        <li class="list-group-item mt-1" :class="{ open: question.show}" :id="question.slug">
                            <button href="#" @click="question.show=!question.show"
                                    class="btn btn-link btn-block collapsed btn-question">
                                {{ question.q }}
                                <img class="icon-arrow" src="@/assets/icon-arrow.svg" height="20em">
                            </button>
                            <b-collapse :visible="question.show" role="tabpanel" :id="''+index2"
                                        :accordion="''+index" @input="question.show = $event" class="faq-answer">
                                <div class="d-flex">
                                    <span class="faq-answer-content">{{ question.a }}</span>
                                    <img v-for="(img, imgIndex) in question.images" :src="img" :key="imgIndex"
                                         class="pl-3 pr-5">
                                </div>
                            </b-collapse>
                        </li>
                    </ul>

                </div>

            </div>

            <div class="my-5 text-center">

                <h3 class="text-center font-weight-bolder">{{ $t('pages.faq.contact_section_title') }} </h3>
                <h4>{{ $t('pages.faq.contact_section_sub_title') }} </h4>
                <a class="btn btn-primary mt-4" target="_blank" :href="contactUrl">
                    {{ $t('pages.faq.btn_contact_us') }}
                </a>

                <div class="mt-5">
                    <p>
                        {{ $t('pages.faq.assistance_avl_title') }} <br>
                        <strong>{{ $t('pages.faq.assistance_avl_days') }}</strong>
                    </p>
                    <p>
                        9:00 - 13:00 <br>
                        14:00 - 18:00
                    </p>
                    <p>
                        {{ $t('pages.faq.assistance_close_days') }}
                    </p>
                </div>
            </div>

        </template>
    </section>
</template>


<script>
import ViewLoader from "@/components/ViewLoader"
import ViewHeader from '@/components/ViewHeader'
import {getBrowserLanguage} from "@/i18n";
import {getContactUrl} from "@/utils";

export default {
    name: 'FaqPage',
    metaInfo: {
        // title will be injected into parent titleTemplate
        title: 'FAQ'
    },

    components: {
        ViewLoader,
        ViewHeader,
    },

    data() {
        return {
            loading: true,
            searchInput: '',
            searchResults: [],
            questionsByGroup: [],
            questionsByGroupIt: [
                {
                    group: 'Le più ricercate',
                    icon: require('@/assets/icon-faq-best.svg'),
                    questions: [
                        {
                            q: 'Dove trovo il mio Pica Code?',
                            a: 'Il Pica Code è un codice alfanumerico che si trova sul tuo pettorale o frontalino o su sticker adesivo in corrispondenza di un rettangolo composto da moduli bianchi e neri.',
                            images: [require('@/assets/picacode.svg')],
                            show: false
                        },
                        {
                            q: 'Ho smarrito il mio Pica Code, come posso guardare le mie foto?',
                            a: 'Per recuperare il tuo Pica Code è necessario comunicare il tuo numero di gara a support@getpica.com specificando l’evento a cui hai partecipato.',
                            show: false
                        },
                        {
                            q: 'Dove ricevo le mie foto?',
                            a: 'Una volta acquistate le foto, riceverai una mail di conferma del tuo ordine. Questo significa che sarà possibile accedere su sito o app Pica per visualizzare, condividere sui social ed effettuare il download delle foto.',
                            show: false
                        },
                        {
                            q: 'Se acquisto alcune foto e poi voglio acquistare il pacchetto completo?',
                            a: 'Non c’è nessun problema, scrivi a support@getpica.com la tua richiesta e riceverai le istruzioni per effettuare il saldo della differenza.',
                            show: false
                        },
                        {
                            q: 'Quando e come ricevo le foto in alta risoluzione (HD)?',
                            a: 'La versione in alta risoluzione delle foto acquistate è disponibile secondo le tempistiche e modalità indicate per l’evento. Per avere questo dettaglio è sufficiente fare clic sull’icona di download in corrispondenza della foto acquistate',
                            show: false
                        }
                    ]
                },
                {
                    group: 'Scopri Pica',
                    icon: require('@/assets/icon-faq-discover.svg'),
                    questions: [
                        {
                            q: 'Cos’è Pica?',
                            a: 'Pica è la piattaforma utilizzata dai migliori studi fotografici per la distribuzione e vendita delle foto. La tecnologia Pica permette di ricevere subito le foto della tua gara direttamente su smartphone e nel completo rispetto della privacy.',
                            show: false
                        },
                        {
                            q: 'Cos’è il Pica Code?',
                            a: 'Il Pica Code è un codice grafico-alfanumerico (si presenta come un insieme di moduli bianchi e neri disposti all\'interno di una cornice rettangolare) che permette alla tecnologia Pica di riconoscere e abbinare le foto alle persone fotografate.\n' +
                                'È importante che il Pica Code sia ben visibile al momento dello scatto.\n',
                            images: [require('@/assets/picacode.svg')],
                            show: false
                        },
                        {
                            q: 'Dove trovo il mio Pica Code?',
                            a: 'Il Pica Code è un codice alfanumerico che si trova sul tuo pettorale o frontalino o su sticker adesivo in corrispondenza di un rettangolo composto da moduli bianchi e neri.',
                            images: [require('@/assets/picacode.svg')],
                            show: false
                        },
                        {
                            q: 'Chi mi scatta le foto?',
                            a: 'Sono affiliati alla piattaforma Pica solo ed esclusivamente studi fotografici accreditati e specializzati negli eventi sportivi. I fotografi si dispongono nei punti più strategici lungo il percorso in modo da ritrarti nei momenti migliori della gara, come un vero professionista!',
                            show: false
                        },
                        {
                            q: 'Perché mi devo registrare?',
                            a: 'Pica richiede la registrazione tramite email per garantire l’unicità dell’accesso da parte dei propri iscritti. Questo passaggio, congiuntamente alla visione delle foto previo l’inserimento del Pica Code, tutela maggiormente la tua Privacy.',
                            show: false
                        },
                        {
                            q: 'Ho smarrito il mio Pica Code, come posso guardare le mie foto?',
                            a: 'Per recuperare il tuo Pica Code è necessario comunicare il tuo numero di gara a support@getpica.com specificando l’evento a cui hai partecipato.',
                            show: false
                        },
                        {
                            q: 'Chi può vedere le mie foto?',
                            a: 'Solo il soggetto ritratto nelle foto può visualizzare le proprie foto. Le foto non saranno mai pubblicate né accessibili da altri se non da il diretto interessato.',
                            show: false
                        },
                        {
                            q: 'Posso vedere le foto di altre persone?',
                            a: 'Sì, per potere visualizzare le foto di altre persone è necessario essere registrati su Pica e conoscere il Pica Code di altre persone.',
                            show: false
                        },
                        {
                            q: 'Dove ricevo le mie foto?',
                            a: 'Una volta acquistate le foto, riceverai una mail di conferma del tuo ordine. Questo significa che sarà possibile accedere su sito o app Pica per visualizzare, condividere sui social ed effettuare il download delle foto.',
                            show: false
                        }
                    ]
                },
                {
                    group: 'Acquisto e Ordini',
                    icon: require('@/assets/icon-faq-orders.svg'),
                    questions: [
                        {
                            q: 'Come posso vedere e/o acquistare le mie foto?',
                            a: 'Registrati su Pica (sito o app) inserendo il tuo indirizzo email e una password segreta,\n' +
                                'inserisci il Pica Code (codice alfanumerico) che è presente su pettorale o frontalino o su sticker adesivo, seleziona le foto che intendi acquistare oppure acquista il pacchetto completo con tutte le tue foto. Una volta acquistate, le foto saranno subito disponibili direttamente su app o sito.\n',
                            show: false
                        },
                        {
                            q: 'Se acquisto alcune foto e poi voglio acquistare il pacchetto completo?',
                            a: 'Non c’è nessun problema, scrivi a support@getpica.com la tua richiesta e riceverai le istruzioni per effettuare il saldo della differenza.',
                            show: false
                        },
                        {
                            q: 'Quali metodi di pagamento posso utilizzare?',
                            a: 'L’acquisto può essere completato con carta di credito, carta di debito, carta prepagata o bonifico bancario.\n' +
                                'Pagando con bonifico bancario, dovrai attendere solo il tempo tecnico della banca per elaborare il pagamento.\n' +
                                'Appena visualizzeremo l’accredito, le tue foto saranno disponibili in app e su sito.',
                            show: false
                        },
                        {
                            q: 'Perché non riesco ad acquistare le foto sul mio dispositivo Apple iOS?',
                            a: 'L’acquisto con la modalità "Acquisti In-App" di Apple, ovvero l\'acquisto che avviene tramite Touch ID/Face ID o password con il proprio Apple ID, non è abilitato per ragioni amministrative.\n' +
                                'È possibile effettuare l\'acquisto sul sito www.getpica.com o su app Pica da dispositivo Android.\n' +
                                'L’acquisto effettuato su sito web o su app Android permetterà in ogni caso di visualizzare le foto anche sui dispositivi Apple iOS.',
                            show: false
                        }
                    ]
                },
                {
                    group: 'Le tue foto',
                    icon: require('@/assets/icon-faq-photos.svg'),
                    questions: [
                        {
                            q: 'Quando e come ricevo le foto in alta risoluzione (HD)?',
                            a: 'La versione in alta risoluzione delle foto acquistate è disponibile secondo le tempistiche e modalità indicate per l’evento. Per avere questo dettaglio è sufficiente fare clic sull’icona di download in corrispondenza della foto acquistate',
                            show: false
                        },
                        {
                            q: 'Perché le mie foto sono coperte da watermark?',
                            a: 'Prima di acquistare le foto, Pica mostra le foto con watermark per tutelare la proprietà intellettuale degli studi fotografici affiliati. Acquistando le foto potrai vedere e scaricare le foto senza watermark.',
                            show: false
                        },
                        {
                            q: 'È presente un logo nelle foto?',
                            a: 'Nelle foto che acquisti non sarà presente nessun logo e in più riceverai la versione in alta risoluzione delle foto acquistate.',
                            show: false
                        },
                        {
                            q: 'Compare il messaggio “altre foto in arrivo”, cosa significa?',
                            a: 'La tecnologia Pica elabora durante e dopo l’evento le foto di tutti i partecipanti. Quando saranno caricate tutte le foto, su app, se hai consentito alla ricezione di notifiche push, riceverai l’avviso che tutte le foto dell’evento sono state caricate. Quando saranno caricate tutte le foto scomparirà automaticamente il messaggio “altre foto in arrivo”.',
                            show: false
                        },
                        {
                            q: 'Ci sono poche foto che mi ritraggono, perché?',
                            a: 'Se nella tua sezione foto compare il messaggio “altre foto in arrivo” significa che il sistema sta elaborando le foto dei partecipanti e pertanto potrebbero essere disponibili entro breve le tue foto.\n' +
                                'Se invece c’è scritto che l’evento è terminato, potrebbe significare che il tuo Pica Code era coperto o non riconoscibile.',
                            show: false
                        }
                    ]
                }
            ],
            questionsByGroupEs: [
                {
                    group: 'Preguntas frecuentes',
                    icon: require('@/assets/icon-faq-best.svg'),
                    questions: [
                        {
                            q: '¿Dónde encuentro mi Pica Code?',
                            a: 'El Pica Code es un código compuesto por letras y números que se encuentra impreso en tu dorsal, debajo de los rectángulos compuesto por cuadraditos blancos y negros.',
                            images: [require('@/assets/picacode.svg')],
                            show: false
                        },
                        {
                            q: '¿No encuentro mi Pica Code, cómo puedo mirar mis fotos?',
                            a: 'Para recuperar el Pica Code, escribe a support@getpica.com, especificando el número de dorsal y la carrera a la que participaste',
                            show: false
                        },
                        {
                            q: '¿Dónde recibo mis fotos?',
                            a: 'Una vez que has comprado tus fotos, las podrás ver directamente en la App o en la web sin marca de agua, así las podrás compartir en redes sociales y descargar en alta resolución.',
                            show: false
                        },
                        {
                            q: '¿Qué pasa si compro algunas fotos y después quiero compra el paquete?',
                            a: 'No hay ningún problema, escribe a support@getpica.com tu petición, y te daremos las indicaciones para efectuar el pago de la diferencia.',
                            show: false
                        },
                        {
                            q: '¿Cómo y cuándo recibo las fotos en alta resolución?',
                            a: 'La versión en alta resolución de las fotos compradas, está disponible en base a los tiempos y las modalidades especificadas en cada evento. Para saber esa información, hacer clic en el icono de download al lado de las fotos compradas',
                            show: false
                        }
                    ]
                },
                {
                    group: 'Descubre Pica',
                    icon: require('@/assets/icon-faq-discover.svg'),
                    questions: [
                        {
                            q: '¿Qué es Pica?',
                            a: 'Pica es la plataforma usada por los mejores fotógrafos para distribuir y vender sus fotos. La tecnología Pica permite recibir al instante las fotos de tu carrera, directamente en tu smartphone y de acuerdo a las normas de privacy.',
                            show: false
                        },
                        {
                            q: '¿Qué es el Pica Code?',
                            a: 'El Pica Code es un código gráfico-alfanumérico (varios módulos blancos y negros en el interior de un marco rectangular) que permite a la tecnología Pica de emparejar las fotos a las personas emparejadas.\n' +
                                'Es importante que el Pica Code esté bien visible en el momento de la toma de la foto.\n',
                            images: [require('@/assets/picacode.svg')],
                            show: false
                        },
                        {
                            q: '¿Dónde encuentro mi  Pica Code?',
                            a: 'El Pica Code es un código alfanumérico que se encuentra en tu pectoral cerca del marco rectangular compuesto por módulos blancos y negros.',
                            images: [require('@/assets/picacode.svg')],
                            show: false
                        },
                        {
                            q: '¿Quién me saca las fotos?',
                            a: 'Los fotógrafos son afiliados a la plataforma Pica, son sólo y exclusivamente estudios fotográficos acreditados y especializados en fotografía deportiva. Los fotógrafos se disponen en los mejores puntos del recorrido para sacarte la foto en los mejores momentos de la carrera, como un verdadero profesionista!',
                            show: false
                        },
                        {
                            q: 'Porque me tengo que registrar en la plataforma?',
                            a: 'Pica solicita el acceso con tu mail para garantizar la unicidad del acceso por parte de los propios inscritos. Este paso, conjuntamente a la visualización de las fotos gracias a haber insertado el Pica Code, preserva todavía más tu privacidad.',
                            show: false
                        },
                        {
                            q: '¿He perdido mi Pica Code, como puedo ver las fotos?',
                            a: 'Para recuperar tus fotos es necesario que nos comuniques tu numero de dorsal de la carrera a support@getpica.com especificando el evento en el cual has participado.',
                            show: false
                        },
                        {
                            q: '¿Quién puede ver mis fotos?',
                            a: 'Solamente quien salga en las fotos, las puede ver. Las fotos no estarán nunca publicadas, ni serán accesibles, si no es por el directo interesado.',
                            show: false
                        },
                        {
                            q: '¿Puedo ver fotos de otras personas?',
                            a: 'Sì, para poder ver sus fotos tienes que estar registrado en Pica y conocer su Pica Code.',
                            show: false
                        },
                        {
                            q: '¿Donde recibo mis fotos?',
                            a: 'Una vez compradas las fotos, te llegará una mail de confirma. Esto significa que será posible acceder en por la web o por la aplicación Pica para visualizar, compartir en las redes y descargar las fotos.',
                            show: false
                        }
                    ]
                },
                {
                    group: 'Compras y Pedidos',
                    icon: require('@/assets/icon-faq-orders.svg'),
                    questions: [
                        {
                            q: '¿Cómo puedo ver y/o comprar mis fotos?',
                            a: 'Registrate en Pica (web o app) insertando tu mail y una contraseña secreta,\n' +
                                'inserta tu Pica Code (código alfanumérico) que se encuentra en el dorsal, selecciona las fotos que deseas comprar o bien el paquete completo de todas tus fotos. Una vez compradas, las fotos estarán instantáneamente en la app o página web.\n',
                            show: false
                        },
                        {
                            q: '¿Si compro algunas fotos y después quiero comprar el paquete completo?',
                            a: 'No hay ningún problema, escribe a support@getpica.com tu petición y recibirás los pasos a seguir para efectuar la diferencia de precio.',
                            show: false
                        },
                        {
                            q: '¿Cuáles métodos de pagamento se pueden utilizar?',
                            a: 'La compra se puede realizar mediante tarjeta de crédito, tarjeta de débito, tarjeta de prepago o transferencia bancaria.\n' +
                                'Pagando mediante transferencia bancaria, tendrás que esperar solamente el tiempo técnico para que el banco elabore el pagamento.\n' +
                                'En cuanto visualicemos el pagamento, tus fotos estarán disponibles en la app o la web.',
                            show: false
                        },
                        {
                            q: '¿Por qué no consigo comprar las fotos mediante mi dispositivo Apple iOS?',
                            a: 'La compra mediante la modalidad “Compra In-App” de Apple, osea la compra que ocurre mediante Touch ID/Face ID o contraseña con el propio Apple ID, no está habilitado por motivos administrativos.\n' +
                                'Es posible efectuar la compra en la web www.getpica.com o en la app Pica desde dispositivo Android.\n' +
                                'La compra efectuada en la web o su App Android permitirá de todas formas de visualizar las fotos en los dispositivos Apple iOS.',
                            show: false
                        }
                    ]
                },
                {
                    group: 'Tus fotos',
                    icon: require('@/assets/icon-faq-photos.svg'),
                    questions: [
                        {
                            q: '¿Cuándo y cómo  recibiré las fotos en alta resolución (HD)?',
                            a: 'La versión de las fotos en alta resolución estará disponible dependiendo de la tempistica y la modalidad del evento.Para saber esto en detalle basta con pulsar download, cerca de la foto comprada',
                            show: false
                        },
                        {
                            q: '¿Porque mis fotos están cubiertas por marcas de agua?',
                            a: 'Antes de haber comprado las fotos, Pica muestra las fotos con marca de agua para tutelar la propiedad intelectual de los estudios fotográficos afiliados. Comprando las fotos, podrás ver y descargar estas sin marca de agua.',
                            show: false
                        },
                        {
                            q: '¿Está presente algún logo en las fotos?',
                            a: 'En las fotos compradas no estará presente ningún logo, además recibiras la versión en alta resolución de estas.',
                            show: false
                        },
                        {
                            q: '¿Qué significa el mensaje “otras fotos a punto de llegar”?',
                            a: 'La tecnología Pica elabora a lo largo y después del evento las fotos de todos los participantes.Cuando todas las fotos estén subidas, en la app, si has consentido las notificaciones push, recibirás el aviso de que todas las fotos del evento han sido subidas. Cuando todas estén subidas desaparecerá automáticamente el mensaje “otras fotos a punto de llegar”.',
                            show: false
                        },
                        {
                            q: '¿Por qué salgo en muy pocas fotos?',
                            a: 'Si en tu selección de fotos aparece el mensaje “otras fotos a punto de llegar” significa que el sistema está procesando las fotos de los participantes y por ello tus fotos estarán disponibles dentro de poco.\n' +
                                'Si en cambio aparece que el evento ha terminado, podría ser porque a lo largo del evento tu Pica Code o dorsal estaba tapado o no reconocible.',
                            show: false
                        }
                    ]
                }
            ],
            questionsByGroupDe: [
                {
                    group: 'Häufig gestellte Fragen',
                    icon: require('@/assets/icon-faq-best.svg'),
                    questions: [
                        {
                            q: 'Wo ist der Pica Code?',
                            a: 'Der Pica Code ist die alphanumerische Sequenz, die Sie unter dem QR-Code auf Ihrer Startnummer, Ihrem Nummernschild oder Ihrem Aufkleber finden können.',
                            images: [require('@/assets/picacode.svg')],
                            show: false
                        },
                        {
                            q: 'Ich habe meinen Pica-Code verloren, wie kann ich mir meine Fotos ansehen?',
                            a: 'Um Ihren Pica Code abzurufen, schreiben Sie uns bitte Ihren Startnummer und den Namen der Veranstaltung, an der Sie teilgenommen haben, unter support@getpica.com',
                            show: false
                        },
                        {
                            q: 'Wo bekomme ich meine Fotos?',
                            a: 'Nachdem Sie Ihre Fotos gekauft haben, erhalten Sie eine E-mail mit Ihrer Bestellnummer. Ab diesem Zeitpunkt werden Ihre Fotos zum Download auf unserer Website oder App verfügbar und Sie können sie Sharing auf den bekanntesten sozialen Medien.',
                            show: false
                        },
                        {
                            q: 'Was machen, wenn ich nur ein paar Fotos gekauft habe und ich das ganze Paket kaufen möchte?',
                            a: 'Kein Problem! Kontaktieren Sie uns unter support@getpica.com mit Ihrer Anfrage und wir werden Ihnen mit allen Details antworten, um Ihre Bestellung abzuschließen.',
                            show: false
                        },
                        {
                            q: 'Wann erhalte ich meine HD-Fotos? Wie erhalte ich sie?',
                            a: 'Das Datum der Veröffentlichung von HD-Fotos kann je nach dem Ereignis, an dem Sie teilgenommen haben, variieren. Um das Veröffentlichungsdatum zu sehen, klicken Sie bitte auf das Cloud-Symbol, das Sie auf jedem Foto finden.',
                            show: false
                        }
                    ]
                },
                {
                    group: 'Mehr über Pica',
                    icon: require('@/assets/icon-faq-discover.svg'),
                    questions: [
                        {
                            q: 'Was ist Pica?',
                            a: 'Pica ist die Plattform für die Lieferung und den Verkauf von Fotos, die von den besten Fotoagenturen verwendet werden. Diese Technologie ermöglicht es Athleten, sofort Fotos des Rennens auf ihren Smartphones unter vollständiger Einhaltung der geltenden allgemeinen Datenschutzverordnung zu erhalten.',
                            show: false
                        },
                        {
                            q: 'Was ist den Pica Code?',
                            a: 'Der Pica Code ist die alphanumerische Sequenz, die Sie unter dem QR-Code auf Ihrer Rennnummer finden können. Es ermöglicht die automatische Übereinstimmung der Fotos mit der dargestellten Person.\n' +
                                'Der Pica Code muss sichtbar sein, um von der Kamera aufgenommen zu werden.\n',
                            images: [require('@/assets/picacode.svg')],
                            show: false
                        },
                        {
                            q: 'Wo ist der Pica Code?',
                            a: 'Der Pica Code ist die alphanumerische Sequenz, die Sie unter dem QR-Code auf Ihrer Startnummer, Ihrem Nummernschild oder Ihrem Aufkleber finden können.',
                            images: [require('@/assets/picacode.svg')],
                            show: false
                        },
                        {
                            q: 'Wer ist für die Fotos verantwortlich?',
                            a: 'Pica arbeitet nur mit akkreditierten Fotoagenturen, diese Agenturen sind auf Sportveranstaltungen spezialisiert.Fotografen werden an den besten Plätzen entlang des Kurses sein und Sie im besten Moment Ihres Rennens porträtieren!',
                            show: false
                        },
                        {
                            q: 'Warum sollte ich mich auf der Website oder App registrieren?',
                            a: 'Pica benötigt eine E-mail-Registrierung, um einen eindeutigen Zugang für seine Abonnenten zu gewährleisten. Dieser Schritt, zusammen mit der Ansicht der Fotos erst nach der Eingabe eines einzigartigen Pica Codes, schützt Ihre Privatsphäre noch mehr.',
                            show: false
                        },
                        {
                            q: 'Ich habe meinen Pica-Code verloren, wie kann ich mir meine Fotos ansehen?',
                            a: 'Um Ihren Pica Code abzurufen, schreiben Sie uns bitte Ihren Startnummer und den Namen der Veranstaltung, an der Sie teilgenommen haben, unter support@getpica.com',
                            show: false
                        },
                        {
                            q: 'Wer kann meine Fotos ansehen?',
                            a: 'Nur die im Bild dargestellten Personen können sich ihre eigenen Fotos anschauen. Fotos werden niemals veröffentlicht oder von jemand anderem als der betroffenen Person zugänglich gemacht.',
                            show: false
                        },
                        {
                            q: 'Kann ich mir Fotos von anderen Personen als mir ansehen?',
                            a: 'Ja, aber dazu müssen Sie sich auf unserem System registrieren und den persönlichen und einzigartigen Pica Code dieser anderen Personen kennen.',
                            show: false
                        },
                        {
                            q: 'Wo bekomme ich meine Fotos?',
                            a: 'Nachdem Sie Ihre Fotos gekauft haben, erhalten Sie eine E-mail mit Ihrer Bestellnummer. Ab diesem Zeitpunkt werden Ihre Fotos verfügbar zum Download auf unserer Website oder App und Sharing auf den bekanntesten sozialen Medien.',
                            show: false
                        }
                    ]
                },
                {
                    group: 'Kauf und Bestellungen',
                    icon: require('@/assets/icon-faq-orders.svg'),
                    questions: [
                        {
                            q: 'Wie kann ich meine Fotos ansehen und/oder kaufen?',
                            a: 'Registrieren Sie sich auf Pica (Website oder App), indem Sie Ihre E-mail-Adresse und ein geheimes Passwort eingeben,\n' +
                                'geben Sie Ihren Pica Code (die alphanumerische Sequenz) ein, den Sie auf Ihrem Startnummer, Nummernschild oder Aufkleber finden. Dann wählen Sie die Fotos aus, die Sie kaufen werden, oder wählen Sie einfach das komplette Fotopaket aus. Sobald Sie sie gekauft haben, werden Fotos auf unserer Website oder App verfügbar sein.\n',
                            show: false
                        },
                        {
                            q: 'Was machen, wenn ich nur ein paar Fotos gekauft habe und ich das ganze Paket kaufen möchte?',
                            a: 'Kein Problem! Kontaktieren Sie uns unter support@getpica.com mit Ihrer Anfrage und wir werden Ihnen mit allen Details antworten, um Ihre Bestellung abzuschließen.',
                            show: false
                        },
                        {
                            q: 'Wie kann ich meine Fotos kaufen?',
                            a: 'Sie können Ihre Fotos per Kreditkarte, Debitkarte oder Banküberweisung kaufen.\n' +
                                'Falls Sie eine Überweisung wählen, informieren wir Sie, dass Fotos - sowohl auf unserer Website als auch in der App - verfügbar sind, sobald die Überweisung freigegeben ist.\n',
                            show: false
                        },
                        {
                            q: 'Ich kann keine Fotos mit meinem Apple iOS Gerät kaufen, warum?',
                            a: 'Der "In-App Einkauf" auf Apple-Geräten wurde aus administrativen Gründen deaktiviert. Sie können Ihre Fotos mit einem Apple-Gerät auf der Website www.getpica.com kaufen.',
                            show: false
                        }
                    ]
                },
                {
                    group: 'Ihre Fotos',
                    icon: require('@/assets/icon-faq-photos.svg'),
                    questions: [
                        {
                            q: 'Wann erhalte ich meine HD-Fotos? Wie erhalte ich sie?',
                            a: 'Das Datum der Veröffentlichung von HD-Fotos kann je nach dem Ereignis, an dem Sie teilgenommen haben, variieren. Um das Veröffentlichungsdatum zu sehen, klicken Sie bitte auf das Cloud-Symbol, das Sie auf jedem Foto finden.',
                            show: false
                        },
                        {
                            q: 'Warum ist ein Wasserzeichen auf meinen Fotos?',
                            a: 'Das geistige Eigentum von Fotos ist für uns sehr wichtig und wir wollen unsere Fotoagenturen schützen. Daher finden Sie ein Wasserzeichen auf Fotos. Durch den Kauf von Fotos können Sie Fotos ohne Wasserzeichen anzeigen und herunterladen.',
                            show: false
                        },
                        {
                            q: 'Ist da ein Logo auf meinen Fotos?',
                            a: 'Es gibt keine Logos auf den Fotos, die Sie kaufen werden, und Sie werden Fotos auch in HD erhalten.',
                            show: false
                        },
                        {
                            q: '"Mehr Fotos kommen", was bedeutet das?',
                            a: 'Pica-Technologie verarbeitet Fotos aller Teilnehmer während und nach der Veranstaltung. Wenn alle Fotos in die App hochgeladen werden, wenn Sie Push-Benachrichtigungen auf Ihrem Gerät zugelassen haben, erhalten Sie eine Warnung, dass alle Fotos des Events hochgeladen wurden. Wenn alle Fotos geladen sind, verschwindet automatisch die Nachricht "mehr Fotos".',
                            show: false
                        },
                        {
                            q: 'Ich habe nur ein paar Fotos gefunden, warum?',
                            a: 'Wenn Sie "die Fotoagentur lädt mehr Fotos" lesen, bedeutet das, dass unser System noch immer die Fotos erkennt, die für die Veranstaltung hochgeladen wurden, und diese Fotos könnten bald verfügbar sein.',
                            show: false
                        }
                    ]
                }
            ],
            questionsByGroupEn: [
                {
                    group: 'Most popular',
                    icon: require('@/assets/icon-faq-best.svg'),
                    questions: [
                        {
                            q: 'What is the access code and where can I find it?',
                            a: 'The code is a 9-digit alphanumeric sequence that you have to enter on getpica.com to access your photo album.\n' +
                                'The code is printed on your bib near a rectangle made up of black and white boxes.',
                            images: [require('@/assets/picacode.svg')],
                            show: false
                        },
                        {
                            q: 'How can I view and/or purchase my photos?',
                            a: 'After logging in or registering on getpica.com, you will need to enter the 9-digit alphanumeric code to access your album. You can then purchase the complete album by selecting "Buy all photos" or add the photos you prefer to your cart. You can take a look at the "Price list" to check the price of one or more photos. You will then have to proceed to checkout, choose the preferred payment method and complete the purchase.\n' +
                                'Please always check the items in your cart before making any purchases.',
                            show: false
                        },
                        {
                            q: 'Which payment methods are accepted?',
                            a: 'Purchases can be made by:\n' +
                                '• Credit card (MasterCard, Visa, American Express, etc...)\n' +
                                '• Debit card\n' +
                                '• Any prepaid card\n' +
                                '• Bank transfer\n' +
                                'For purchases made by bank transfer, the photos will be available as soon as we receive the payment, usually within 3-4 working days.\n' +
                                'For all other payment methods, the photos will be available as soon as the purchase is completed.\n' +
                                'Please always check the items in your cart before making any purchases.',
                            show: false
                        },
                        {
                            q: 'How do I receive my photos?',
                            a: 'To view and download the photos you have purchased, please return to our website getpica.com and visit the selected album.\n' +
                                'If you purchased all the photos, the unlocked album is displayed. If you have purchased a selection of photos, simply go to the "Purchased" section to view them.\n' +
                                'You can browse your album at any time, and share and download the photos in high resolution.',
                            show: false
                        },
                        {
                            q: 'What happens if I purchase a selection of photos and later on decide to buy the complete photo album?',
                            a: 'After your first purchase, the price for the full album will update automatically, displaying the difference between the initial price of the full album and the amount that has been already paid. You will just have to carry out the payment for the remaining balance.\n' +
                                'Please always check the items in your cart before making any purchases.',
                            show: false
                        }
                    ]
                },
                {
                    group: 'Discover getpica.com',
                    icon: require('@/assets/icon-faq-discover.svg'),
                    questions: [
                        {
                            q: 'What is Pica?',
                            a: 'Pica ®️ is the revolutionary tech solution for the distribution and sale of photos and videos chosen by the best photo agencies. Our technology allows you to view photos of events you attended in real time and right on your devices, and to keep them with you at all times.\n' +
                                'Accredited photo studios only are affiliated to the platform Pica, and they use the service to deliver photos in full compliance with users\' privacy',
                            show: false
                        },
                        {
                            q: 'How do I receive my photos?',
                            a: 'To view and download the photos you have purchased, please return to our website getpica.com and visit the selected album.\n' +
                                'If you purchased all the photos, the unlocked album is displayed. If you have purchased a selection of photos, simply go to the "Purchased" section to view them.\n' +
                                'You can browse your album at any time, and share and download the photos in high resolution.',
                            show: false
                        },
                    ]
                },
                {
                    group: 'Placing orders and payments',
                    icon: require('@/assets/icon-faq-orders.svg'),
                    questions: [
                        {
                            q: 'How can I view and/or purchase my photos?',
                            a: 'After logging in or registering on getpica.com, you will need to enter the 9-digit alphanumeric code to access your album. You can then purchase the complete album by selecting "Buy all photos" or add the photos you prefer to your cart. You can take a look at the "Price list" to check the price of one or more photos. You will then have to proceed to checkout, choose the preferred payment method and complete the purchase.\n' +
                                'Please always check the items in your cart before making any purchases.\n',
                            show: false
                        },
                        {
                            q: 'Which payment methods are accepted?',
                            a: 'Purchases can be made by:\n' +
                                '• Credit card (MasterCard, Visa, American Express, etc...)\n' +
                                '• Debit card\n' +
                                '• Any prepaid card\n' +
                                '• Bank transfer\n' +
                                'For purchases made by bank transfer, the photos will be available as soon as we receive the payment, usually within 3-4 working days.\n' +
                                'For all other payment methods, the photos will be available as soon as the purchase is completed.\n' +
                                'Please always check the items in your cart before making any purchases.',
                            show: false
                        },
                        {
                            q: 'What happens if I buy the complete album and more photos are added after purchase?',
                            a: 'When purchasing the complete album, all photos added afterwards will automatically be included in the package you have already paid for. No additional purchases will be necessary.',
                            show: false
                        },
                        {
                            q: 'I have purchased one or several photos and the price is now lower, why?',
                            a: 'The platform automatically displays the price to be paid for the items left in the album, calculated on the amount of the purchase already made. You are never going to pay more than the price of the full album, even if you purchase at different times.',
                            show: false
                        },

                    ]
                },
                {
                    group: 'My photos',
                    icon: require('@/assets/icon-faq-photos.svg'),
                    questions: [
                        {
                            q: 'What does "Come back later! You could receive other photos for this album" mean?',
                            a: 'If some photos are already available in your album, it means that more may be added.\n' +
                                'Should there be no pictures, we suggest waiting a few days after the event to allow photographers to finish uploading. If there are still no pictures in your album later on, please get in touch with customer service, stating the name of the event and your bib number.\n' +
                                'We advise waiting for previews before making purchases.',
                            show: false
                        },
                        {
                            q: 'Can I take a look at my photos before purchasing them?',
                            a: 'Sure! Before purchasing, photos in the album are watermarked yet partially visible in preview, so you can choose your favourites. If no preview is available, please contact us at support@getpica.com, stating the name of the event you attended and your bib number.',
                            show: false
                        },
                    ]
                }
            ]

        }
    },

    created() {
        this.loading = false

        // TODO: temp solution to be removed once we have the questions stored on the backend
        const lang = this.$store.state.appConfig.language || getBrowserLanguage()

        this.loadFaq(lang)

        this.$root.$on('language-changed', lang => {
            this.loadFaq(lang)
        })
    },

    beforeCreate() {
        this.loading = false
    },

    computed: {
      contactUrl(){
        return this.getContactUrl(this.$route.params.eventName || null)
      }
    },

    methods: {
      getContactUrl,
        loadFaq(lang) {
            const toSlug = (s) => {
                return s.toLowerCase()
                    .replace(/[àáâãäå]/g, 'a')
                    .replace(/[èéêëėē]/g, 'e')
                    .replace(/[ìíîïįī]/g, 'i')
                    .replace(/[òóôöõœøō]/g, 'o')
                    .replace(/[ùúûüū]/g, 'u')
                    .replace(/ /g, '-')
                    .replace(/[^\w-]+/g, '')
            }

            if (lang === 'es') {
                this.questionsByGroup = this.questionsByGroupEs
            } else if (lang === 'de') {
                this.questionsByGroup = this.questionsByGroupDe
            } else if (lang === 'it') {
                this.questionsByGroup = this.questionsByGroupIt
            } else {
                this.questionsByGroup = this.questionsByGroupEn
            }
            this.questionsByGroup.forEach(i => {
                i['slug'] = toSlug(i.group)
                i.questions.forEach(j => {
                    j['slug'] = i['slug'] + '_' + toSlug(j.q)
                    j.show = false
                })
            })
        },
        searchQuestions() {
            const q = this.searchInput.toLowerCase()
            if (q) this.searchResults = this.questionsByGroup
                .map(i => i.questions).flat()
                .filter(
                    i => i.q.toLowerCase().includes(q) || i.a.toLowerCase().includes(q))
                .filter((q, index, array) => index === array.findIndex(i => i.q === q.q)) // remove duplicates
                .slice(0, 4) // max 5 results
            else this.searchResults = []
        },
        scrollToGroup(group) {
            this.$router.push({hash: group.slug}, () => {
            }, () => {
                // navigation duplicated
                this.$router.push({}, () => this.scrollToGroup(group))
            })
        },
        scrollToQuestion(question) {
            this.$router.push({hash: question.slug}, () => {
                // Open the answer after 500ms
                setTimeout(() => {
                    document.querySelector(`#${question.slug} button`).click()
                }, 500)
                this.searchInput = ''
            }, () => {
                // navigation duplicated error handler
                this.$router.push({}, () => this.scrollToQuestion(question))
            })
        }
    }
}
</script>
